import React from 'react';
import { FormattedMessage } from 'react-intl';

import { getOptimisticPublicationDateI18n } from './get-optimistic-publication-date-i18n';

type Props = {
  date: string;
};

export const OptimisticPublicationDate: React.FC<Props> = ({ date }) => {
  const { id, values = {} } = getOptimisticPublicationDateI18n(date);
  return <FormattedMessage id={id} values={values} />;
};
